import { env, localStorage } from '@fiverr-private/futile';
import { HELPFUL_STORAGE_KEY } from '../../constants';

const KEYS = {
    REVIEWS_HISTORY: 'reviews-history',
};

const ssrStorageMock = {
    [KEYS.REVIEWS_HISTORY]: [],
};

const defaultStorage = {
    [KEYS.REVIEWS_HISTORY]: [],
};

const get = (key) => {
    if (!env.browser) {
        return ssrStorageMock[key];
    }

    return localStorage.get(key) || defaultStorage[key];
};

const set = (key, value) => {
    if (env.browser) {
        return localStorage.set(key, value);
    }
};

const getHelpfulReviewsList = () => get(HELPFUL_STORAGE_KEY) || {};

export default { get, set, getHelpfulReviewsList };
